import { render, staticRenderFns } from "./ThemeDialog.vue?vue&type=template&id=3b7a64d4&scoped=true&"
import script from "./ThemeDialog.vue?vue&type=script&lang=js&"
export * from "./ThemeDialog.vue?vue&type=script&lang=js&"
import style0 from "./ThemeDialog.vue?vue&type=style&index=0&id=3b7a64d4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a64d4",
  null
  
)

export default component.exports